import { render, staticRenderFns } from "./ExpiredSubscriptionNotification.vue?vue&type=template&id=1cc32ea3&scoped=true&"
import script from "./ExpiredSubscriptionNotification.vue?vue&type=script&lang=ts&"
export * from "./ExpiredSubscriptionNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ExpiredSubscriptionNotification.vue?vue&type=style&index=0&id=1cc32ea3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc32ea3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
